module.exports = __webpack_public_path__ + "static/media/lotto.dcbc622d.gif";